module.exports = __webpack_public_path__ + "img/malfunctions.f98fe763.jpg";